(ns frontend.ui.component.lp-portal.report.company.value-chart.controller
  (:require
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]))

(defn config->editable-data
  [config]
  {:chart-key      :valuation
   :columns        (some->> config
                            :xAxis
                            (mapcat :categories)
                            (vec))
   :data           (->> config
                        :series
                        (mapv (fn [serie]
                                (vec (concat [(:name serie)]
                                             (:data serie))))))
   :y-axis-config  (chart-utils/config->editable-y-axis-data config)
   :tooltip-config (chart-utils/config->editable-tooltip-data config)})

(defn editable-data->raw-data
  [edited-data]
  (let [hardcoded-keys [:gross-multiple :ev-by-ebitda :ev-by-net-sales]]
    (merge {:labels (:columns edited-data)}
           {:series-names (mapv first (:data edited-data))}
           (->> edited-data
                :data
                (map-indexed (fn [idx row]
                               (let [number-data (->> row
                                                      rest
                                                      (map (fn [item]
                                                             (when (number? item) item)))
                                                      vec)]
                                 (if-let [key (get hardcoded-keys idx)]
                                   [key number-data]
                                   (js/console.warn "Cannot resolve data " row)))))
                (into {})))))

(defn company-valuation
  [{:keys [labels y-axis-config tooltip-config gross-multiple ev-by-ebitda ev-by-net-sales series-names]}]
  (let [y-axis-1 (chart-utils/resolve-editable-axis-data (first y-axis-config) chart-utils/axis-mult-formatter "Money multiple")
        y-axis-2 (chart-utils/resolve-editable-axis-data (second y-axis-config) chart-utils/axis-mult-formatter "EV / EBITDA")
        y-axis-3 (chart-utils/resolve-editable-axis-data (last y-axis-config) chart-utils/axis-mult-formatter "EV / Sales")
        tooltip-1 (chart-utils/resolve-editable-tooltip-data (first tooltip-config) chart-utils/mult-formatter)
        tooltip-2 (chart-utils/resolve-editable-tooltip-data (second tooltip-config) chart-utils/mult-formatter)
        tooltip-3 (chart-utils/resolve-editable-tooltip-data (last tooltip-config) chart-utils/mult-formatter)
        series-name-1 (chart-utils/resolve-series-name (first series-names) "Money multiple")
        series-name-2 (chart-utils/resolve-series-name (second series-names) "EV / EBITDA")
        series-name-3 (chart-utils/resolve-series-name (last series-names) "EV / Sales")
        gross-multiple? (boolean (some number? gross-multiple))
        ev-by-ebitda? (boolean (some number? ev-by-ebitda))
        ev-by-net-sales? (boolean (some number? ev-by-net-sales))]
    {:chart       {:zoomType "xy"}
     :xAxis       [{:categories    labels
                    :showEmpty     false
                    :lineColor     (theme/color [:chart :x-axis :line])
                    :gridLineColor (theme/color [:chart :x-axis :grid-line])}]
     :yAxis       [{:title         {:text (:title-text y-axis-1)}
                    :labels        {:formatter (:formatter-fn y-axis-1)}
                    :visible       gross-multiple?
                    :softMin       0
                    :softMax       0
                    :id            0
                    :lineColor     (theme/color [:chart :y-axis :line])
                    :gridLineColor (theme/color [:chart :y-axis :grid-line])}
                   {:title         {:text (:title-text y-axis-2)}
                    :opposite      true
                    :visible       ev-by-ebitda?
                    :softMin       0
                    :softMax       0
                    :id            1
                    :labels        {:formatter (:formatter-fn y-axis-2)}
                    :lineColor     (theme/color [:chart :y-axis :line])
                    :gridLineColor (theme/color [:chart :y-axis :grid-line])}
                   {:title         {:text (:title-text y-axis-3)}
                    :opposite      true
                    :visible       ev-by-net-sales?
                    :softMin       0
                    :softMax       0
                    :id            2
                    :labels        {:formatter (:formatter-fn y-axis-3)}
                    :lineColor     (theme/color [:chart :y-axis :line])
                    :gridLineColor (theme/color [:chart :y-axis :grid-line])}]
     :colors      (or (util/custom-colors)
                      (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                            [:lp-report :chart :bar :gradient-end]
                                            3))
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :shared          true}
     :plotOptions {:line {:marker {:enabled false}}}
     :series      [{:name         series-name-1
                    :type         "column"
                    :data         gross-multiple
                    :yAxis        0
                    :visible      gross-multiple?
                    :showInLegend gross-multiple?
                    :tooltip      {:outside         true
                                   :useHtml         true
                                   :backgroundColor (theme/color [:page-bg :bg])
                                   :style           {:opacity         1
                                                     :backgroundColor (theme/color [:page-bg :bg])}
                                   :pointFormatter  (:formatter-fn tooltip-1)}}
                   {:name         series-name-2
                    :type         "line"
                    :data         ev-by-ebitda
                    :yAxis        1
                    :visible      ev-by-ebitda?
                    :showInLegend ev-by-ebitda?
                    :tooltip      {:outside         true
                                   :useHtml         true
                                   :backgroundColor (theme/color [:page-bg :bg])
                                   :style           {:opacity         1
                                                     :backgroundColor (theme/color [:page-bg :bg])}
                                   :pointFormatter  (:formatter-fn tooltip-2)}}
                   {:name         series-name-3
                    :type         "line"
                    :data         ev-by-net-sales
                    :yAxis        2
                    :visible      ev-by-net-sales?
                    :showInLegend ev-by-net-sales?
                    :tooltip      {:outside         true
                                   :useHtml         true
                                   :backgroundColor (theme/color [:page-bg :bg])
                                   :style           {:opacity         1
                                                     :backgroundColor (theme/color [:page-bg :bg])}
                                   :pointFormatter  (:formatter-fn tooltip-3)}}]}))
